import React, { useContext, useEffect } from 'react';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import {
  EditDisclaimerWrapper,
  AlertIcon,
  Disclaimer,
  DisclaimerText,
  Link
} from './PurchaseDisclaimer.styles';

type OwnProps = {
  isIn7DMBG?: boolean;
  isOrderInProgress?: boolean;
  isOrderPlaced?: boolean;
};

export default function PurchaseDisclaimer({
  isIn7DMBG,
  isOrderPlaced,
  isOrderInProgress
}: OwnProps) {
  const { trackEvent } = useContext(AnalyticsContext);

  useEffect(() => {
    trackEvent('Account - Personal Details - Disable Edit Due To Order Status', {
      isIn7DMBG,
      isOrderPlaced,
      isOrderInProgress
    });
  }, []);

  return (
    <EditDisclaimerWrapper>
      <AlertIcon />
      <Disclaimer>
        {isIn7DMBG ? (
          <DisclaimerText>
            During the 7-Day Money Back Guarantee period, editing your information is temporarily
            restricted. Once this period ends, you will regain the ability to modify your details
            for future purchases.
          </DisclaimerText>
        ) : (
          <DisclaimerText>
            You have a current purchase. To edit your information, please{' '}
            <Link
              href={
                isOrderInProgress
                  ? '/purchase/steps/personal-details/entry'
                  : '/purchase/steps/order-placed'
              }
              onClick={trackEvent(
                'Account - Personal Details - Clicked Click Here - Purchase Page Redirect',
                { isOrderPlaced, isOrderInProgress }
              )}
            >
              click here
            </Link>{' '}
            for next steps.
          </DisclaimerText>
        )}
      </Disclaimer>
    </EditDisclaimerWrapper>
  );
}
